const myCard = {
    nfts: () => import("@/common/ListCard/Card/nftsCard"),
    dealings: () => import("@/common/ListCard/Card/dealingsCard"),
    synthesize: () => import("@/common/ListCard/Card/synthesizeCard"),
    raffle: () => import("@/common/ListCard/Card/raffleCard"),
    convertible: () => import("@/common/ListCard/Card/convertibleCard"),
    myNft: () => import("@/common/ListCard/Card/myNftCard"),
    myOrder: () => import("@/common/ListCard/Card/myOrderCard"),
    myGoods: () => import("@/common/ListCard/Card/myGoodsCard"),
    myLocker: () => import("@/common/ListCard/Card/myLockerCard"),
    myLockerPose: () => import("@/common/ListCard/Card/myLockerPoseCard"),
    announceMentCard: () => import("@/common/ListCard/Card/announceMentCard"),
  };
  export default myCard;